const itemsApporve = [
	{
		id: 2,
		key: 2,
		name: "status.approved"
	},
	{
		id: -1,
		key: -1,
		name: "status.rejected"
	},
	{
		id: 1,
		key:1,
		name: "status.waiting"
	}
];

export default itemsApporve;